import { Pipe, PipeTransform } from '@angular/core';
import { IStatus, Status } from '@routes/events/models/ticketallocation-model';
import { IVenueModel } from '@shared/models/venue.model';
import { IEventLocationDateTimeStatus } from '@shared/services/api/legacy/events-service/event-model';

@Pipe({
  name: 'chartStatus'
})
export class ChartStatusPipe implements PipeTransform {

  public transform(eventLocationDateTime: IEventLocationDateTimeStatus[], locationDateTime: IVenueModel): IStatus {
    let status: IStatus  = null;
    if (locationDateTime && eventLocationDateTime.find(x => x.id === locationDateTime.id)) {
      status = eventLocationDateTime.find(x => x.id === locationDateTime.id).status;
    }

    if (!status) {
      status = new Status([], locationDateTime.capacity);
    }

    return status;
  }

}
